export const env = {
  apiUrl: process.env.VUE_APP_API_URL
}
